import { useEffect } from 'react';
import useSelectedBusiness from './useSelectedBusiness';
import { BusinessSubscriptionType } from '../../types/misc';
import {
  getMinimumBusinessSubscriptionForFeatures,
  isBusinessSubscriptionGreaterThanOrEqual,
} from '../../utils/BusinessFeatureUtils';
import businessService from '../../services/business/businessService';

export default function useActiveBusinessSubscription(): BusinessSubscriptionType {
  const business = useSelectedBusiness();

  let subscriptionType: BusinessSubscriptionType = BusinessSubscriptionType.STARTER;
  if (business) {
    if (business.trialEndDate && new Date(business.trialEndDate) > new Date()) {
      subscriptionType = business.trialType || BusinessSubscriptionType.STARTER;
    } else {
      subscriptionType = business.subscription?.type ?? BusinessSubscriptionType.STARTER;
    }
  }

  // Downgrade features asynchronously if the active subscription no longer supports them
  useEffect(() => {
    if (!business || (!business.trialEndDate && !business.subscription)) return;
    const currentFeatures = business.dashboard?.features || {};
    const requiredSubscription = getMinimumBusinessSubscriptionForFeatures(currentFeatures);
    if (isBusinessSubscriptionGreaterThanOrEqual(subscriptionType, requiredSubscription)) return;
    const { name, description, dashboard } = business;
    if (!dashboard?.features) return;
    const featuresCopy = { ...dashboard.features, FINANCIAL_ADMINISTRATION: false };
    businessService.updateBusiness(name, description, featuresCopy);
  }, [subscriptionType, business?.dashboard?.features]);

  return subscriptionType;
}
